
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/[country]",
      function () {
        return require("private-next-pages/projects/[country]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/[country]"])
      });
    }
  